import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from './Navigation';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-page">
      <Navigation />
      <div className="dashboard-container">
        {/* Hero/Intro Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div className="hero-left">
              <h1 className="hero-title">
                Transform Your Forensic Analysis with Advanced AI Technology
              </h1>
            </div>
            <div className="hero-right">
              <p className="hero-description">
                Forensic AI empowers investigators and analysts to process evidence faster, extract critical insights, 
                and build stronger cases through intelligent image analysis, audio transcription, and advanced pattern 
                recognition powered by state-of-the-art machine learning models.
              </p>
              <div className="hero-actions">
                <button 
                  onClick={() => navigate('/analysis')}
                  className="hero-cta-btn"
                >
                  Start Analysis
                  <i className="fas fa-arrow-right"></i>
                </button>
                <button 
                  onClick={() => navigate('/documents')}
                  className="hero-cta-btn secondary"
                >
                  <i className="fas fa-upload"></i>
                  Upload Company Literature
                </button>
              </div>
            </div>
          </div>
          <div className="hero-pattern"></div>
        </div>

        {/* Main Content */}
        <div className="dashboard-grid">
          {/* Forensic AI Main Card */}
          <div className="dashboard-card main-card">
            {/* <h2>Forensic AI</h2>
            <p className="card-description">
              This is your professional forensic analysis dashboard. You can now access all the powerful 
              features of the Forensic AI system including case management, image analysis, audio processing, 
              and advanced AI-powered insights.
            </p> */}
            <div className="actions-grid actions-grid--parallel">
              <div className="action-column">
                <button
                  type="button"
                  onClick={() => navigate('/analysis')}
                  className="action-card primary"
                >
                  <div className="action-card-inner">
                    <div className="action-icon">
                      <img src="/icon.png" alt="Forensic AI Logo" className="action-logo" />
                    </div>
                    <div className="action-content">
                      <h3>AI Analysis</h3>
                      <p>Start new forensic analysis with advanced AI models for image processing, audio transcription, and pattern recognition</p>
                    </div>
                    <div className="action-card-footer">
                      <span className="action-cta-label">Open</span>
                      <span className="action-arrow" aria-hidden>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </button>
              </div>
              <div className="action-column">
                <button
                  type="button"
                  onClick={() => navigate('/cases')}
                  className="action-card cases-card"
                >
                  <div className="action-card-inner">
                    <div className="action-icon">
                      <i className="fas fa-folder-open"></i>
                    </div>
                    <div className="action-content">
                      <h3>View Cases</h3>
                      <p>Review your forensic cases with documentation and analysis tools</p>
                    </div>
                    <div className="action-card-footer">
                      <span className="action-cta-label">Browse</span>
                      <span className="action-arrow" aria-hidden>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </button>
              </div>
              <div className="action-column">
                <button
                  type="button"
                  onClick={() => navigate('/documents')}
                  className="action-card documents-card"
                >
                  <div className="action-card-inner">
                    <div className="action-icon">
                      <i className="fas fa-file-alt"></i>
                    </div>
                    <div className="action-content">
                      <h3>Document Library</h3>
                      <p>Upload and manage documents for RAG search, test queries, and similarity-ranked results</p>
                    </div>
                    <div className="action-card-footer">
                      <span className="action-cta-label">Library</span>
                      <span className="action-arrow" aria-hidden>
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 